export function commaSeparatedNumber(num: number) {
    let numStr = num.toString();

    for (let i = numStr.length - 3; i >= 0; i -= 3) {
        if (i > 0) {
            let left = numStr.substring(0, i);
            let right = numStr.substring(i, numStr.length);
            numStr = left + ',' + right;
        }
    }

    return numStr;
}
